module.exports = __webpack_public_path__ + "img/pse.f4f20fb1.png";